import { downloadAdvancedSearchResults } from './downloadAdvancedSearchResults';
import { countUniqueFoundResults } from './deduplicateSuggestions';

export const handleDownloadAdvancedSearch = async (
  suggestionsData: any[],
  searchType: string,
  selectedFilter: string,
  text: string,
  totalSearched: number,
  selectedItems?: any[],
) => {
  try {
    const isSelectedDownload = Boolean(selectedItems && selectedItems.length > 0);
    const totalFound = isSelectedDownload ? selectedItems!.length : countUniqueFoundResults(suggestionsData);

    await downloadAdvancedSearchResults({
      suggestionsData,
      searchType,
      selectedFilter,
      text,
      totalSearched: isSelectedDownload ? selectedItems!.length : totalSearched,
      totalFound,
      selectedItems: isSelectedDownload ? selectedItems : undefined,
    });
  } catch (error) {
    console.error('Error downloading results:', error);
  }
};
